<script setup>
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
import { Head, Link } from '@inertiajs/vue3';
import FrontendLayout from '@/Layouts/FrontendLayout.vue';

const props = defineProps({
    post: {
        type: Array,
        required: true
    }
})
</script>
<template>

    <Head title="Blog title will be go here" />
    <FrontendLayout>
        <section class="container 2xl:px-24 xl:px-0 mx-auto sm:py-16 wow animate__animated animate__fadeInLeft">
            <Link :href="route('blog.page')" preserve-scroll
                class="inline-flex items-center justify-end cursor-pointer uppercase bg-white hover:bg-blue-50 border border-blue-500 px-3 py-2 text-[#1565C0] rounded focus:outline-none transition mt-4 mb-4 text-sm font-medium">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                class="text-[#1565C0] w-5 h-5 mr-2 inline-block">
                <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"></path>
            </svg>Back</Link>

            <div>
                <div class="w-full h-full">
                    <!-- <div class="w-full h-[700px]"> -->
                    <VLazyImage :src="post?.image" :alt="post?.title"
                        class="h-full w-full object-cover object-top inline-block" />
                </div>

                <div class="pt-6 pb-3 border-b">
                    <h1 class="title-font sm:text-3xl text-xl text-black mb-2 leading-relaxed font-semibold">{{
                        locale === 'BN' ? post?.bn_title : post?.title }}</h1>
                    <p class="text-gray-500 text-xs font-light">{{ post?.created_at.human_long }}</p>
                </div>
                <div class="mt-4" v-html="locale === 'BN' ? post?.bn_content : post?.content"></div>

            </div>

        </section>
    </FrontendLayout>
</template>
<style scoped></style>
